/*
 * NuovaGlam™ Period Relief Belt : pyjamas offerts du kit, selon le panier réel (20/10/2026).
 * Même mécanique que assets/ng-wm-cart-sync.js (Washer) : la ligne ceinture porte ses propriétés privées
 *   _ng_lv_offer (single / kit / double) et _ng_lv_gifts (IDs des variantes de pyjama choisies, séparés par des virgules),
 *   écrites par sections/ng-lv-product.liquid. Les pyjamas (produit UNLISTED à 0 €, valeur barrée 49,95 €) sont posés et
 *   retirés via le fetch d'une iframe vide (aucun AddToCart Meta en plus), propriété privée _ng_lv_gift + mention visible
 *   « Gift » (standard bundles §3quater : l'agent expédie toutes les lignes sauf NG-DIGITAL-*).
 * Quantité : chaque ligne ceinture donne ses pyjamas × sa quantité réelle (− / + du tiroir compris). Une ceinture supprimée
 *   retire ses pyjamas ; un pyjama sans ceinture est retiré. Idempotent (plusieurs passages ne dupliquent rien).
 * Propriété distincte des autres fiches (_ng_wm_gift, _ng_sb_gift…) : leurs scripts ne touchent jamais ces lignes.
 * Vitesse (21/10/2026, mesuré : « + » 2,3 s contre 0,69 s chez la source) : 4 allers-retours ramenés à 1 après le natif —
 *   le panier publié par le tiroir natif (cartData) remplace la relecture de cart.js, et le tiroir re-rendu est demandé
 *   DANS la mutation des pyjamas (paramètre sections) au lieu d'un fetch séparé ; le nombre de pyjamas s'affiche dès le
 *   clic (optimiste), le serveur confirme ensuite. Le − / + de la ceinture reste la requête native (AddToCart Meta juste).
 */
(() => {
  if (window.__ngLvCartSync) return;
  window.__ngLvCartSync = true;
  const GIFT_VARIANTS = [58921959948619, 58921959981387];   /* One-Size Pyjama Set — Pink, White */
  const SOURCE = 'ng-lv-sync';
  const GIFT_KEY = 'Gift';
  const GIFT_VALUE = 'Included with your offer';
  const route = (path) => (window.Shopify?.routes?.root || '/') + path;
  const absolute = (path) => window.location.origin + route(path);
  let rawFetch = null;
  function cleanFetch() {
    if (rawFetch) return rawFetch;
    try {
      const frame = document.createElement('iframe');
      frame.hidden = true;
      frame.setAttribute('aria-hidden', 'true');
      frame.tabIndex = -1;
      document.body.appendChild(frame);
      rawFetch = frame.contentWindow.fetch.bind(frame.contentWindow);
    } catch (e) {
      rawFetch = window.fetch.bind(window);
    }
    return rawFetch;
  }

  function plan(cart) {
    const items = cart.items || [];
    const need = new Map();
    const tags = new Map();   /* étiquette d'offre recopiée sur le pyjama (1re ceinture qui le demande) */
    items.filter((i) => i.properties && i.properties._ng_lv_offer).forEach((line) => {
      String(line.properties._ng_lv_gifts || '').split(',').map((x) => Number(x.trim())).filter(Boolean).forEach((id) => {
        need.set(id, (need.get(id) || 0) + line.quantity);
        if (!tags.has(id) && line.properties._ng_lv_gift_tag) tags.set(id, line.properties._ng_lv_gift_tag);
      });
    });
    const known = new Set(GIFT_VARIANTS.concat([...need.keys()]));
    const gifts = items.filter((i) => i.properties && i.properties._ng_lv_gift);
    const strays = items.filter((i) => known.has(i.variant_id) && !(i.properties && i.properties._ng_lv_gift));
    const updates = {};
    const have = new Map();
    gifts.forEach((g) => {
      const want = need.get(g.variant_id) || 0;
      if (have.has(g.variant_id) || want === 0) { updates[g.key] = 0; return; }
      have.set(g.variant_id, true);
      if (g.quantity !== want) updates[g.key] = want;
    });
    strays.forEach((g) => { updates[g.key] = 0; });
    if (Object.keys(updates).length) return { step: 'update', updates };
    const add = [...need.entries()].filter(([id, q]) => q > 0 && !have.has(id))
      .map(([id, q]) => ({ id, quantity: q, properties: Object.assign({ _ng_lv_gift: 'period-belt', [GIFT_KEY]: GIFT_VALUE }, tags.has(id) ? { _ng_offer_tag: tags.get(id) } : {}) }));
    return add.length ? { step: 'add', items: add } : null;
  }

  async function readCart() {
    const r = await fetch(route('cart.js'), { headers: { Accept: 'application/json' }, cache: 'no-store', credentials: 'same-origin' });
    if (!r.ok) throw new Error(`cart ${r.status}`);
    return r.json();
  }
  /* Sections du tiroir / de la page panier à re-rendre, demandées dans la mutation elle-même. */
  function hostsToRender() {
    const hosts = ['cart-drawer-items', 'cart-items']
      .map((s) => document.querySelector(s))
      .filter((h) => h && typeof h.getSectionsToRender === 'function')
      .map((host) => ({ host, sections: host.getSectionsToRender() }));
    const drawer = document.querySelector('cart-drawer');
    if (!hosts.length && drawer && typeof drawer.getSectionsToRender === 'function') hosts.push({ host: drawer, sections: drawer.getSectionsToRender().map((s) => ({ id: s.id, section: s.section || s.id, selector: s.selector })) });
    return hosts;
  }
  const sectionIds = (hosts) => [...new Set(hosts.flatMap(({ sections }) => sections.map((s) => s.section)))];

  async function post(path, body) {
    const r = await cleanFetch()(absolute(path), { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
    const data = await r.json().catch(() => ({}));
    if (!r.ok || data.status) throw new Error(data.description || data.message || `${path} ${r.status}`);
    return data;
  }

  /* Re-rendu avec le contrat natif CartItems (tiroir + page panier), comme assets/ng-wm-cart-sync.js. */
  async function render(cart, given) {
    const hosts = hostsToRender();
    const drawer = document.querySelector('cart-drawer');
    if (!hosts.length) return;
    const ids = sectionIds(hosts);
    let html = given && ids.every((id) => typeof given[id] === 'string') ? given : null;
    if (!html) {
      const r = await fetch(`${route('cart')}?sections=${ids.join(',')}`, { credentials: 'same-origin', cache: 'no-store' });
      if (!r.ok) throw new Error(`sections ${r.status}`);
      html = await r.json();
    }
    const empty = cart.item_count === 0;
    hosts.forEach(({ host, sections }) => {
      host.classList.toggle('is-empty', empty);
      sections.forEach((s) => {
        const el = document.getElementById(s.id);
        if (!el || typeof html[s.section] !== 'string') return;
        const target = (s.selector && el.querySelector(s.selector)) || el;
        const markup = typeof host.getSectionInnerHTML === 'function'
          ? host.getSectionInnerHTML(html[s.section], s.selector)
          : new DOMParser().parseFromString(html[s.section], 'text/html').querySelector(s.selector || '.shopify-section')?.innerHTML;
        if (typeof markup === 'string') target.innerHTML = markup;
      });
    });
    drawer?.classList.toggle('is-empty', empty);
    document.getElementById('main-cart-footer')?.classList.toggle('is-empty', empty);
  }

  const isCart = (c) => c && Array.isArray(c.items) && typeof c.item_count === 'number';
  async function reconcile(given) {
    let cart = isCart(given) ? given : await readCart();
    let changed = false;
    let sections = null;
    const ids = sectionIds(hostsToRender());
    const extra = ids.length ? { sections: ids, sections_url: window.location.pathname } : {};
    for (let i = 0; i < 4; i += 1) {
      const next = plan(cart);
      if (!next) break;
      changed = true;
      if (next.step === 'update') {
        const data = await post('cart/update.js', Object.assign({ updates: next.updates }, extra));
        sections = data.sections || null;
        cart = data;
      } else {
        const data = await post('cart/add.js', Object.assign({ items: next.items }, extra));
        sections = data.sections || null;
        cart = await readCart();
      }
    }
    return changed ? { cart, sections } : null;
  }

  /* Affichage immédiat du nombre de pyjamas au − / + d'une ceinture (le serveur confirme juste après). */
  function optimistic(event) {
    const btn = event.target.closest && event.target.closest('cart-drawer button[name="plus"], cart-drawer button[name="minus"]');
    if (!btn) return;
    const row = btn.closest('.cart-item');
    const input = row && row.querySelector('input.quantity__input');
    if (!row || !input || !/Belt/i.test(row.textContent)) return;
    const next = Math.max(0, (Number(input.value) || 0) + (btn.name === 'plus' ? 1 : -1));
    const prev = Number(input.value) || 0;
    if (!prev) return;
    document.querySelectorAll('cart-drawer .ngcp-esc-qtyfix').forEach((box) => {
      const q = Number(box.textContent) || 0;
      const nq = Math.round((q / prev) * next);
      if (nq <= 0 || !q) return;
      box.textContent = String(nq);
      /* prix barré du pyjama = valeur unitaire × nouvelle quantité, au même format que l'affichage */
      const old = box.closest('.cart-item')?.querySelector('.cart-item__totals .cart-item__old-price');
      const m = old && old.textContent.match(/([\d.,]+)/);
      if (m) {
        const unit = Number(m[1].replace(/[.,](?=\d{3}\b)/g, '').replace(',', '.')) / q;
        /* devise réelle du marché (29/10/2026) : formateur commun window.NGMoney (assets/ng-cart-profile.js) */
        const cents = Math.round(unit * nq * 100);
        old.textContent = window.NGMoney ? window.NGMoney.format(cents)
          : new Intl.NumberFormat('en-IE', { style: 'currency', currency: (window.Shopify?.currency?.active) || 'EUR' }).format(cents / 100);
      }
    });
  }

  let queue = Promise.resolve();
  const run = (given) => {
    queue = queue.then(async () => {
      try {
        const done = await reconcile(given);
        if (done) {
          await render(done.cart, done.sections);
          /* Pas de cartUpdate ici : le tiroir et la pastille sont déjà re-rendus depuis la réponse ; l'annoncer faisait
             re-télécharger tout le tiroir par CartItems (+300 ms, double affichage, mesuré le 21/10/2026). */
          document.dispatchEvent(new CustomEvent('ng-lv:cart-synced', { detail: { cart: done.cart } }));
        }
      } catch (e) {
        console.error('[NuovaGlam Belt cart sync]', e);
      }
    });
    return queue;
  };

  window.NuovaGlamBeltCart = { plan, reconcile, run, idle: () => queue };
  const start = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => { if (event?.source !== SOURCE) setTimeout(() => run(event && event.cartData), 0); });
    }
    document.addEventListener('click', optimistic, true);
    run();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
